import { PROMOTIONS_URL } from 'constants/config';
import { fetchJson as fetch } from 'utils/fetchJson/fetchJson';

const promotions = {
  subscribe: senderEmail => {
    const payload = {
      email: senderEmail,
    };
    const body = JSON.stringify(payload);
    const options = { body, method: 'POST' };

    return fetch(PROMOTIONS_URL, options);
  },
};

export { promotions };
